import { useCallback, useEffect, useState } from "react"
import MyModal from "../MyModal"
import Input from "../Input"
import { editUser } from "../../services/userApis"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"
import { toast } from "react-toastify"

const EditUserModal = ({ user }) => {
    const { isConnected, sendMessage } = useSocket()

    const [isOpen, setIsOpen] = useState(false)
    const [companyList, setCompanyList] = useState(null)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const handleCompanyList = useCallback((data) => {
        setCompanyList(data)
    }, [])

    useSocketEvent("companyList", handleCompanyList)

    const handleSubmit = (e) => {
        e.preventDefault()

        toggleModal()

        const form = new FormData(e.target)

        let data = {
            userId: user.id,
            password: form.get("password"),
            balance: form.get("balance"),
            scope: form.get("scope"),
            companyName: form.get("company-name"),
            info: form.get("info"),
            canUseBot: form.get("can-use-bot") == "on" ? true : false,
            canUseManagerBot: form.get("can-use-manager-bot") == "on" ? true : false,
            canUseServers: form.get("can-use-servers") == "on" ? true : false,
            canUseRanksystems: form.get("can-use-ranksystems") == "on" ? true : false,
            canUseBanner: form.get("can-use-banner") == "on" ? true : false,
            canUseJts3: form.get("can-use-jts3") == "on" ? true : false,
        }

        toast.promise(editUser(data), {
            pending: "درحال ویرایش کاربر",
            success: "کاربر با موفقیت ساخته شد",
        })
    }

    useEffect(() => {
        if (isOpen && isConnected) {
            sendMessage("getCompanyList")
        }
    }, [isOpen, isConnected])

    return (
        <>
            <button
                onClick={toggleModal}
                className="flex gap-2 justify-center border border-slate-500 bg-slate-500 text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-slate-600 focus:outline-none focus:shadow-outline"
            >
                <svg
                    fill="none"
                    height="25"
                    viewBox="0 0 24 24"
                    width="25"
                    xmlns="http://www.w3.org/2000/svg"
                    className=" text-xs"
                >
                    <path
                        d="M21.0312 2.96948C22.4286 4.36695 22.4286 6.63268 21.0312 8.03014L18.0393 11.022C17.8618 11.0074 17.6823 11 17.501 11C16.8694 11 16.2588 11.0901 15.6814 11.2581L17.94 8.99939L15.001 6.06039L5.06283 15.9985C4.97054 16.0908 4.90393 16.2055 4.86959 16.3315L3.81974 20.1809L7.66918 19.1311C7.7951 19.0967 7.90988 19.0301 8.00217 18.9378L11.259 15.6808C11.091 16.2581 11.001 16.8685 11.001 17.5C11.001 17.6813 11.0084 17.8608 11.023 18.0384L9.06283 19.9985C8.78596 20.2753 8.44162 20.4752 8.06386 20.5782L2.94817 21.9734C2.38829 22.1261 1.87456 21.6123 2.02726 21.0525L3.42244 15.9368C3.52547 15.559 3.7253 15.2147 4.00217 14.9378L15.9705 2.96948C17.368 1.57202 19.6337 1.57202 21.0312 2.96948ZM17.0312 4.03014L16.061 4.99939L19 7.93939L19.9705 6.96948C20.7822 6.15781 20.7822 4.84182 19.9705 4.03014C19.1588 3.21847 17.8428 3.21847 17.0312 4.03014ZM14.2792 13.9754C14.5939 15.0656 13.9396 16.1991 12.838 16.4716L12.2538 16.6161C12.2089 16.9038 12.1855 17.199 12.1855 17.4998C12.1855 17.8145 12.2111 18.123 12.2601 18.4232L12.7996 18.5532C13.9121 18.8211 14.5734 19.9661 14.2496 21.0636L14.0633 21.6949C14.5024 22.0805 15.0029 22.3937 15.5474 22.6165L16.0407 22.0977C16.8293 21.2685 18.1515 21.2687 18.9398 22.0982L19.4385 22.623C19.9821 22.4027 20.4821 22.0925 20.9213 21.7101L20.7233 21.0242C20.4085 19.9339 21.0629 18.8005 22.1645 18.528L22.7482 18.3835C22.7931 18.0958 22.8165 17.8006 22.8165 17.4998C22.8165 17.1851 22.7909 16.8765 22.7418 16.5762L22.2029 16.4464C21.0904 16.1785 20.4291 15.0335 20.7529 13.9359L20.9391 13.3051C20.4999 12.9193 19.9995 12.6061 19.4549 12.3833L18.9618 12.9018C18.1732 13.7311 16.8509 13.7309 16.0627 12.9013L15.5639 12.3765C15.0203 12.5967 14.5204 12.9068 14.0811 13.2892L14.2792 13.9754ZM17.501 18.9998C16.7004 18.9998 16.0513 18.3282 16.0513 17.4998C16.0513 16.6714 16.7004 15.9998 17.501 15.9998C18.3016 15.9998 18.9507 16.6714 18.9507 17.4998C18.9507 18.3282 18.3016 18.9998 17.501 18.9998Z"
                        fill="#212121"
                    />
                </svg>
                ویرایش کاربر
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="500px">
                <div className="">
                    <form onSubmit={handleSubmit} className="m-2 ml-2">
                        <div className="mt-2 grid grid-cols-2 gap-x-5">
                            <Input
                                type="text"
                                dir="ltr"
                                label={"نام کاربری"}
                                placeholder={"نام کاربری"}
                                defaultValue={user.username}
                                disabled={true}
                            />

                            <Input
                                type="password"
                                dir="ltr"
                                label={"پسورد"}
                                placeholder={"********"}
                                name={"password"}
                            />
                        </div>
                        <div>
                            <div className="mt-2">
                                <label className="block">پکیج ها</label>
                                <select class="styled-select" name="scope">
                                    <option value="admin" selected={user.scope == "admin"}>
                                        ادمین
                                    </option>
                                    <option value="reseller" selected={user.scope == "reseller"}>
                                        نماینده
                                    </option>
                                </select>
                            </div>
                            <Input
                                type="number"
                                dir="ltr"
                                label={"موجودی"}
                                placeholder={"موجودی"}
                                name={"balance"}
                                defaultValue={user.balance}
                                required={true}
                            />
                        </div>
                        <div>
                            <label className="block">اسم کمپانی</label>
                            <select class="styled-select" name="company-name">
                                {companyList &&
                                    companyList.map((item, index) => (
                                        <option key={index} value={item.name} selected={item.name == user.company_name}>
                                            {item.name}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="mt-2">
                            <Input
                                type="text"
                                dir="rtl"
                                label={"توضیحات"}
                                placeholder={"توضیحات"}
                                defaultValue={user.info}
                                name={"info"}
                            />
                        </div>
                        <div className="flex my-1" dir="rtl">
                            ساخت تیم اسپیک: &nbsp;
                            <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                            <label class="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="can-use-servers"
                                    class="sr-only peer"
                                    defaultChecked={user.can_use_servers}
                                />
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                            </label>
                        </div>
                        <div className="flex my-1" dir="rtl">
                            ساخت بات موزیک: &nbsp;
                            <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                            <label class="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="can-use-bot"
                                    class="sr-only peer"
                                    defaultChecked={user.can_use_bot}
                                />
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                            </label>
                        </div>
                        <div className="flex my-1" dir="rtl">
                            ساخت بات مدیریتی: &nbsp;
                            <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                            <label class="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="can-use-manager-bot"
                                    class="sr-only peer"
                                    defaultChecked={user.can_use_manager_bots}
                                />
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                            </label>
                        </div>
                        <div className="flex my-1" dir="rtl">
                            ساخت رنک سیستم: &nbsp;
                            <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                            <label class="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="can-use-ranksystems"
                                    class="sr-only peer"
                                    defaultChecked={user.can_use_ranksystems}
                                />
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                            </label>
                        </div>
                        <div className="flex my-1" dir="rtl">
                            ساخت بنر داینامیک: &nbsp;
                            <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                            <label class="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="can-use-banner"
                                    class="sr-only peer"
                                    defaultChecked={user.can_use_banner}
                                />
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                            </label>
                        </div>
                        <div className="flex my-1" dir="rtl">
                            ساخت کاربر Jts3: &nbsp;
                            <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                            <label class="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="can-use-jts3"
                                    class="sr-only peer"
                                    defaultChecked={user.can_use_jts3}
                                />
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                            </label>
                        </div>
                        <button type="submit" className="styled-button w-full">
                            ویرایش کاربر
                        </button>
                    </form>
                </div>
            </MyModal>
        </>
    )
}

export default EditUserModal
